// Thrown instead of sending a request without a bearer token: the api answers those with 401,
// which is indistinguishable from a rejected token and drops the user onto an error page.
export class TokenUnavailableError extends Error {
  constructor() {
    super("no access token available");
    this.name = "TokenUnavailableError";
  }
}
